import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import styles from './Earnings.module.scss';
  
  const Earnings = () => {
    const {t} = useTranslation();

    useEffect(() => {
      window.location.href = window.location.origin;
    }, []);
  
    return (
      <div className={styles.earning_container}>
        {t('check_your_earning_inside')}&nbsp;<a href={`${window?.location?.origin}${'/earnings/wallet'}`}>Alfan</a>
      </div>
    );
  };
  
  export default Earnings;
